import React, { useState } from 'react';
import { FiRefreshCw, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import AppModal from '../../common/AppModal';
import services from '../../services';
import { toast } from 'react-toastify';

const ReSyncAccount = ({ show, onHide, authEmail }) => {
    const [formData, setFormData] = useState({
        email: authEmail,
        fromDate: '',
        toDate: '',
    });
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        const form = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();

        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setValidated(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const payload = {
                ...formData,
                fromDate: formatDateToDDMMYYYY(formData.fromDate),
                toDate: formatDateToDDMMYYYY(formData.toDate),
            };
            const response = await services.email.SYNC_OLD_MAIL(payload);
            setSuccessMessage('Resynced successfully!');
            setTimeout(() => { onHide(); }, 1000);
            setLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error);
            setErrorMessage(error.response?.data?.message || 'Failed to resync account');
            setLoading(false);
        }
    };

    const footerContent = !loading ? (
        <>
            <button className="app-modal-btn-cancel" type="button" onClick={onHide}>
                Close
            </button>
            <button
                className="app-modal-btn-save"
                type="button"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </>
    ) : null;

    return (
        <AppModal
            show={show}
            onClose={onHide}
            icon={<FiRefreshCw size={17} color="#fff" />}
            title="Sync Old Mail"
            subtitle="Import emails from a specific date range"
            maxWidth="500px"
            footer={footerContent}
        >
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '48px 0' }}>
                    <div className="spinner-border text-success" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <form noValidate onSubmit={handleSubmit}>

                    {/* Alerts */}
                    {errorMessage && (
                        <div className="cred-alert-error">
                            <FiAlertCircle size={14} />
                            {errorMessage}
                        </div>
                    )}
                    {successMessage && (
                        <div className="cred-alert-success">
                            <FiCheckCircle size={14} />
                            {successMessage}
                        </div>
                    )}

                    {/* Email Address */}
                    <div className="eauth-form-group">
                        <label htmlFor="rs-email" className="eauth-form-label">Email Address</label>
                        <input
                            id="rs-email"
                            type="email"
                            name="email"
                            className="eauth-form-input"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter Email"
                            required
                            disabled
                        />
                        {validated && !formData.email && (
                            <div className="eauth-form-feedback">Please provide a valid Email.</div>
                        )}
                    </div>

                    {/* From Date */}
                    <div className="eauth-form-group">
                        <label htmlFor="rs-fromDate" className="eauth-form-label">From</label>
                        <input
                            id="rs-fromDate"
                            type="date"
                            name="fromDate"
                            className="eauth-form-input"
                            value={formData.fromDate}
                            onChange={handleInputChange}
                            placeholder="Enter Start Date"
                            required
                            min={new Date().toISOString().split('T')[0]}
                        />
                        {validated && !formData.fromDate && (
                            <div className="eauth-form-feedback">Please provide a valid Start Date.</div>
                        )}
                    </div>

                    {/* To Date */}
                    <div className="eauth-form-group">
                        <label htmlFor="rs-toDate" className="eauth-form-label">To</label>
                        <input
                            id="rs-toDate"
                            type="date"
                            name="toDate"
                            className="eauth-form-input"
                            value={formData.toDate}
                            onChange={handleInputChange}
                            placeholder="Enter End Date"
                            required
                            min={formData.fromDate}
                            max={(() => {
                                if (!formData.fromDate) return undefined;
                                const d = new Date(formData.fromDate);
                                d.setDate(d.getDate() + 2);
                                return d.toISOString().split('T')[0];
                            })()}
                        />
                        {validated && !formData.toDate && (
                            <div className="eauth-form-feedback">Please provide a valid End Date.</div>
                        )}
                    </div>

                </form>
            )}
        </AppModal>
    );
};

export default ReSyncAccount;
